import {
  getDecodedToken,
  getDecodedTokenWithoutIndex
} from '../results/results.token';

export const JOB_LIST_IMPRESSION = 'JOB_LIST_IMPRESSION';
export const JOB_LIST_IMPRESSION_EXIT = 'JOB_LIST_IMPRESSION_EXIT';

const getDecodedTokens = token => ({
  token: getDecodedToken(token),
  tokenWithoutIndex: getDecodedTokenWithoutIndex(token)
});

export function jobListItemImpression({
  token,
  impressionType = JOB_LIST_IMPRESSION,
  prestoLoggingType = 'searchImpression'
}) {
  return {
    type: impressionType,
    payload: {
      ...getDecodedTokens(token)
    },
    meta: {
      metrics: {
        name: impressionType
      },
      prestoLogging: {
        data: {
          ...getDecodedTokens(token)
        },
        type: prestoLoggingType
      }
    }
  };
}

export function jobListItemImpressionExit({ token }) {
  return jobListItemImpression({
    token,
    impressionType: JOB_LIST_IMPRESSION_EXIT,
    prestoLoggingType: 'searchImpressionExit'
  });
}

const initialState = {
  impressionToken: ''
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case JOB_LIST_IMPRESSION:
    case JOB_LIST_IMPRESSION_EXIT: {
      return {
        ...state,
        impressionToken: action.payload.tokenWithoutIndex
      };
    }
    default: {
      return state;
    }
  }
}
